Hop.defineModule('form-without-empty-values', (root) => {
    const $root = $(root);

    function onSubmit(e) {
        $(':input', e.currentTarget).each((idx, el) => {
            el.disabled = !$(el).val();
        });
    }

    function init() {
        $root.on('submit', onSubmit);
    }

    init();

    return function destroy() {
        $root.off('submit', onSubmit);
    };
});
